import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    padding: theme.spacing.space16,
    flexDirection: "column",
    gap: theme.spacing.space16,
  },
  serviceIcon: {
    width: 30,
    height: 30,
  },
  transactionHistory: {
    marginTop: theme.spacing.space16,
  },
  content: {
    marginTop: theme.spacing.space12,
  },
  htCard: {
    marginTop: theme.spacing.space16,
  },
  htDate: {
    marginBottom: theme.spacing.space16,
  },
}));
